<template>
  <div class="hub-detail bg-white">
    <div class="flex justify-between items-stretch mdmax:flex-col shadow-border-b ">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Drop Point</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <p class="text-neutral-500">{{ hubDetail.id }}</p>
        </div>
        <div class="mb-6 flex gap-6">
          <div class="w-44">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Hub</label>
            <p class="text-neutral-500">{{ hubDetail.name || '-' }}</p>
          </div>
          <div class="w-44">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kode Hub</label>
            <p class="text-neutral-500">{{ hubDetail.hub_code || '-' }}</p>
          </div>
        </div>
        <div class="mb-6 flex gap-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Latitude</label>
            <p class="text-neutral-500 break-all">{{ hubDetail.coord_lat || '-' }}</p>
          </div>
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Longitude</label>
            <p class="text-neutral-500 break-all">{{ hubDetail.coord_lng || '-' }}</p>
          </div>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 block">Map</label>
          <a :href="`https://maps.google.com/?q=${hubDetail.coord_lat},${hubDetail.coord_lng}`" target="_blank" class="text-primary-500">Lihat di google Map</a>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jam Operasional</label>
          <p class="text-neutral-500">{{ hubDetail.operation_hour_display || '-' }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Alamat</label>
          <p class="text-neutral-500">{{ hubDetail.address || '-' }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Provinsi</label>
          <p class="text-neutral-500">{{ hubDetail.province_name || '-' }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kota / Kabupaten</label>
          <p class="text-neutral-500">{{ hubDetail.district_name || '-' }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kecamatan</label>
          <p class="text-neutral-500">{{ hubDetail.subdistrict_name || '-' }}</p>
        </div>
        <div class="">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kelurahan</label>
          <p class="text-neutral-500">{{ hubDetail.urbanvillage_name || '-' }}</p>
        </div>
      </div>
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <div class="p-6 ">
          <p class="font-bold text-lg mb-6">PIC</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama PIC 1</label>
            <p class="text-neutral-500">{{ hubDetail.primary_pic_name || '-' }}</p>
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No Handphone</label>
            <p class="text-neutral-500">{{ hubDetail.primary_pic_phoneno || '-' }}</p>
          </div>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama PIC 2</label>
            <p class="text-neutral-500">{{ hubDetail.secondary_pic_name || '-' }}</p>
          </div>
          <div class="">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No Handphone</label>
            <p class="text-neutral-500">{{ hubDetail.secondary_pic_phoneno || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end mdmax:justify-center">
      <Button buttonText="Hapus" @action="toggleDeleteModal()" type="delete" :size="isMobile ? 'full' : 'regular'" />
      <!-- <Button buttonText="Edit" @action="submit()" :size="isMobile ? 'full' : 'regular'" /> -->
    </div>
    <Modal :modalVisible="visibleDeleteModal" @close="toggleDeleteModal" id="delete-modal">
      <template slot="modal-content">
        <div class=" text-cente mt-6 mb-4">Apakah Anda yakin akan menghapus hub ini?</div>
        <div class="flex justify-center items-center gap-4">
          <Button buttonText="Ya" @action="deleteItem()" type="secondary" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Tidak" @action="toggleDeleteModal()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  data() {
    return {
      visibleDeleteModal: false
    }
  },
  computed: {
    ...mapGetters('hub', ['hubDetail']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    hubId() {
      return this.$route.params.id
    }
  },
  created() {
    this.getHubInformation()
  },
  methods: {
    ...mapActions('hub', ['getHubDetail', 'deleteHub']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getHubInformation() {
      this.getHubDetail({
        partnerId: this.partnerId,
        hubId: this.hubId
      })
    },
    toggleDeleteModal() {
      this.visibleDeleteModal = !this.visibleDeleteModal
    },
    deleteItem() {
      this.showLoading()
      this.deleteHub({
        partnerId: this.partnerId,
        hubId: this.hubId
      }).then(() => {
        this.toggleDeleteModal()
        this.hideLoading()
        this.$router.push('/hub')
      })
    }
  }
}
</script>
